import React, { useEffect, useState } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
// import { useSelector } from 'react-redux'
import { LoginApis } from '../../API/Login/LoginApi'
import InputField from '../inputField'

export default function CreateBusinessProfileForm({ profileInfo, setCreateBusinessProfileMode }) {
    const [editMode, seteditMode] = useState(false)
    const [countries, setCountries] = useState([])
    const [states, setStates] = useState([])
    // const { businessUser } = useSelector((state) => state.Users)

    // console.log("warehousing",Warehouse)
    // console.log("From personal details", user);
    // const { frProUser } = useSelector((state) => state.Users);
    // const dispatch = useDispatch();

    const getCountries = () => {
        LoginApis.getCountries()
            .then((res) => {
                setCountries(res?.data)
                // console.log("countries in updatedForm:", res?.data);
            })
            .catch((err) => console.log('updateprfileForm country error:', err))
            .finally(() => { })
    }

    const getStates = (CountryCode = 'MX') => {
        LoginApis.getStates(CountryCode).then((res) => {
            setStates(res?.data)
            // console.log("states updated by satish",res.data)
        })
    }

    const handleCountryChange = (countryName) => {
        const country = countries?.find((c) => c.countryName === countryName)
        console.log('handleCountryChange', country?.countryId)
        getStates(country?.countryId)
    }

    useEffect(() => {
        getCountries()

        // handleCountryChange()
    }, [])

    const emailRules = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/

    return (
        <Formik
            initialValues={{
                businessName: '',
                email: '',
                mobileNumber: '',
                secondaryMobile: '',
                buisinessLegalName: '',
                einNumber: '',
                uploadArticlesOfBusiness: '',
                uploadBusinessIncorporationDocument: '',
                category: '',
                physicalCountry: '',
                physicalState: '',
                physicalCity: '',
                physicalZip: '',
                physicalZone: '',
                shippingLocation: '',
                shippingState: '',
                shippingCity: '',
                shippingZip: '',
                shippingZone: '',
                sameAddress: '',
                wareHousingServices: '',
                inventoryControl: '',
                crossDocking: '',
                fulfillmentAndPickAndPackServices: '',
                transportationAndTransloading: '',
                wlCountry: '',
                wlState: '',
                wlCity: '',
                wlZip: '',
            }}
            validationSchema={Yup.object().shape({
                // firstName: Yup.string().required(),
                // lastName: Yup.string().required(),
                // gender: Yup.string().required(),
                // category: Yup.string().required(),
                email: Yup.string().matches(emailRules, 'Please provide valid email'),
                // mobile: Yup.string().required(),
                // nativeLocation: Yup.string().required(),
                // nativeState: Yup.string().required(),
                // nativeCity: Yup.string().required(),
                // nativeZone: Yup.string().required(),
                // currentLocation: Yup.string().required(),
                // currentState: Yup.string().required(),
                // currentCity: Yup.string().required(),
                // currentZone: Yup.string().required(),
            })}
            onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                try {
                    // await new Promise((r) => setTimeout(r, 500));
                    setStatus({ success: false })
                    setSubmitting(false)
                    console.log('VAlues from essentialsBusinessInformation', values)

                    let essentialsBusinessInformationObj = {
                        businessName: values?.businessName,
                        email: values?.email,
                        mobileNumber: values?.mobileNumber,
                        secondaryMobile: values?.secondaryMobile,
                        buisinessLegalName: values?.buisinessLegalName,
                        einNumber: values?.einNumber,
                        uploadArticlesOfBusiness: values?.uploadArticlesOfBusiness,
                        uploadBusinessIncorporationDocument:
                            values?.uploadBusinessIncorporationDocument,
                        category: values?.category,
                        physicalCountry: values?.physicalCountry,
                        physicalState: values?.physicalState,
                        physicalCity: values?.physicalCity,
                        physicalZip: values?.physicalZip,
                        physicalZone: values?.physicalZone,
                        shippingLocation: values?.shippingLocation,
                        shippingState: values?.shippingState,
                        shippingCity: values?.shippingCity,
                        shippingZip: values?.shippingZip,
                        shippingZone: values?.shippingZone,
                        sameAddress: values?.sameAddress,
                        wareHousingServices: values?.wareHousingServices,
                        inventoryControl: values?.inventoryControl,
                        crossDocking: values?.crossDocking,
                        fulfillmentAndPickAndPackServices:
                            values?.fulfillmentAndPickAndPackServices,
                        transportationAndTransloading:
                            values?.transportationAndTransloading,
                        wlCountry: values?.wlCountry,
                        wlState: values?.wlState,
                        wlCity: values?.wlCity,
                        wlZip: values?.wlZip,
                    }
                    console.log(
                        'essentialsBusinessInformation data on submit:',
                        essentialsBusinessInformationObj
                    )
                    //TODO
                    // LoginApis.createUser(userObj, authorizationToken)
                    //   .then((res) => {
                    //     console.log(":VAlues from oersonal", res);
                    //     // dispatch(setUser({ user: res }));
                    //     // navigate("/otp", { username: "test" })

                    //     console.log("test:::response", res);
                    //     dispatch(
                    //       setauthorizationToken({
                    //         authorizationToken: res?.data?.fre8ProAccessToken,
                    //       })
                    //     );
                    //     dispatch(setFrProUser({ frProUser: res?.data }));
                    //     if (res?.fre8ProStatus=== "standard") {
                    //       navigate("/profile", { username: "test" });
                    //     } else {
                    //       navigate("/otpscreen", { username: "test" });
                    //     }
                    //   })
                    //   .catch((err) => {
                    //     console.log(":VAlues from personal information", values, err);
                    //     setStatus({ success: false });
                    //     setErrors({ submit: err.message });
                    //     setSubmitting(false);
                    //     // navigate("/error", { err: err })
                    //   })
                    //   .finally(() => {
                    //     //TODO : test code remove thislater
                    //     // navigate("/firstTimeUser", { username: "testy" })
                    //   });
                    // navigate("/otpscreen", { username: "test" })
                } catch (err) {
                    setStatus({ success: false })
                    setErrors({ submit: err.message })
                    setSubmitting(false)
                    console.log('Personal informaation crashed error')
                }
            }}
        >
            {({ errors, handleSubmit, touched, values }) => (
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="col-12 mb-3" id="item-1">
                            <div className="uProfile p30">
                                <div className="row">
                                    <div className="col">
                                        <div className="rHeading">
                                            <h4>
                                                Business Details
                                                <span>
                                                    <a onClick={() => seteditMode((prev) => !prev)}>
                                                        <i
                                                            className={
                                                                editMode
                                                                    ? 'bi bi-x-square'
                                                                    : 'bi bi-pencil-square'
                                                            }
                                                        ></i>
                                                    </a>
                                                </span>
                                            </h4>
                                            <div>
                                                <a href="">
                                                    <i className="bi bi-globe-central-south-asia"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Business name
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Business summary
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Legal business name
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Business number
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            EIN number
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Keywords
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Services offered
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Website
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Primary Email
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Secondary Email
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Primary phone number
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Secondary phone number
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Head office
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Phone number
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Fax
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <label className="form-label fw-medium mb-3">
                                                        Business Address
                                                        {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                    </label>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Address type
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Business address line 1
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Business address line 2
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Area
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Landmark
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label htmlFor="" className="form-label fw-medium">
                                                            Country
                                                        </label>
                                                        <InputField
                                                            tag={'select'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'physicalCountry'}
                                                            touched={touched}
                                                            errors={errors}
                                                            handleCountryChange={handleCountryChange}
                                                        // onChange={(e)=>handleCountryChange(e.target.value)}
                                                        >
                                                            {values.nativeLocation ? (
                                                                ''
                                                            ) : (
                                                                <option>Please select</option>
                                                            )}
                                                            {countries?.map((country) => (
                                                                <option
                                                                    key={country?.countryId}
                                                                    value={country?.countryName}
                                                                >
                                                                    {country?.countryName}
                                                                </option>
                                                            ))}
                                                        </InputField>
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label htmlFor="" className="form-label fw-medium">
                                                            State/Province
                                                        </label>
                                                        <InputField
                                                            tag={'select'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'physicalState'}
                                                            touched={touched}
                                                            errors={errors}
                                                        >
                                                            {values?.nativeState ? (
                                                                ''
                                                            ) : (
                                                                <option>Please select</option>
                                                            )}
                                                            {states?.map((state) => (
                                                                <option
                                                                    key={state.stateId}
                                                                    value={state.stateName}
                                                                >
                                                                    {state?.stateName}
                                                                </option>
                                                            ))}
                                                        </InputField>
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            City
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            ZIP
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                    <div className='mb-3'>
                                                        <label className="form-label fw-medium">
                                                            Remarks
                                                            {/* <sup><i className="bi bi-star-fill"></i></sup> */}
                                                        </label>
                                                        <InputField
                                                            type={'text'}
                                                            values={values}
                                                            editMode={editMode}
                                                            name={'businessName'}
                                                            touched={touched}
                                                            errors={errors}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <button
                                                type={'submit'}
                                                className="btn btn-primary btn-up"
                                            >
                                                Save
                                            </button>
                                            <button
                                                //onClick={() => handleTriggerJobTab('all_jobs')}
                                                type="button"
                                                className="btn custom-button2 rounded-3 border btntext">
                                                Cancel
                                            </button>
                                            <button
                                                onClick={() => setCreateBusinessProfileMode(false)}
                                                className="btn btn-up"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}
        </Formik>
    )
}

CreateBusinessProfileForm.propTypes = {
    profileInfo: PropTypes.object,
    setCreateBusinessProfileMode: PropTypes.func,
}